<template>
  <div class="page_main">
    <!--搜索区域-->
    <div class="search_block">
      <Form :label-width="100" inline>
        <FormItem label="用户名称">
          <Input placeholder="请输入" v-model="table.search.UserName" clearable></Input>
        </FormItem>
        <FormItem label="医院名称">
          <Input placeholder="请输入" v-model="table.search.HospitalName" clearable></Input>
        </FormItem>
      </Form>
      <!--操作区域-->
      <div>
        <Button class="mr-3" type="success" @click="search">查询</Button>
        <Button class="mr-3" type="primary" @click="addModal = true">新增</Button>
        <Button class="mr-3" type="warning" @click="deleteBatch">批量删除</Button>
      </div>

    </div>
    <!--列表区域-->
    <DataTable
      class="mb-5"
      ref="dataTable"
      :columns="table.columns"
      :apiUrl="table.apiUrl"
      :search="table.search"
      :width="500"
      @selectionChange="selectionChange"
    ></DataTable>

    <!--新增-->
    <Modal
      v-model="addModal"
      title="新增密钥"
      :footer-hide="true"
      
      :closable="false"
    >
      <secretadd @close="addModal = false" @loadData="search"></secretadd>
    </Modal>

    <!--更新-->
    <Modal
      v-model="editModal"
      title="更新密钥"
      :footer-hide="true"
      
      :closable="false"
    >
      <secretedit
        v-if="editModal"
        @close="editModal = false"
        @loadData="search"
        :editModelTemp="currentEditModel"
      ></secretedit>
    </Modal>

    <!--详情-->
    <Modal
      v-model="detailModal"
      title="密钥详情"
      :footer-hide="true"
      
      :closable="false"
    >
      <secretdetail
        v-if="detailModal"
        @close="detailModal = false"
        :editModelTemp="currentEditModel"
      ></secretdetail>
    </Modal>
  </div>
</template>
<script>
import DataTable from "@/components/DataTable.vue";
import secretadd from "../secret/add.vue";
import secretedit from "../secret/edit.vue";
import secretdetail from "../secret/detail.vue";

export default {
  components: { DataTable, secretadd, secretedit, secretdetail },
  data: function () {
    return {
      currentEditModel: {},
      detailModal: false,
      addModal: false,
      editModal: false,
      selectionData: [],
      table: {
        columns: [
          {
            type: "selection",
            width: 60,
            align: "center",
          },
          {
            title: "序号",
            key: "",
            type: "index",
            width: "60",
            align: "center",
          },
          { title: "用户名称", key: "userName", tooltip: true, align: "center", width: 150},
          { title: "医院名称", key: "hospitalName", tooltip: true, align: "center", width: 150},
          { title: "秘钥", key: "secret", tooltip: true, align: "center", width: 150},
          { title: "服务名称", key: "serverName", tooltip: true, align: "center", width: 150},
          { title: "hospitalId", key: "hospitalId", tooltip: true, align: "center", width: 150},
          { title: "accessId", key: "accessId", tooltip: true, align: "center", width: 150},
          { title: "achiveApi", key: "achiveApi", tooltip: true, align: "center", width: 150},
          { title: "dImageUrl", key: "dImageUrl", tooltip: true, align: "center", width: 150},
          { title: "deleteFlag", key: "deleteFlag", tooltip: true, align: "center", width: 100},
          { title: "eUnityAddress", key: "eUnityAddress", tooltip: true, align: "center", width: 150},
          { title: "eUnityUser", key: "eUnityUser", tooltip: true, align: "center", width: 150},
          { title: "maxDays", key: "maxDays", tooltip: true, align: "center", width: 100},
          { title: "privateKey", key: "privateKey", tooltip: true, align: "center", width: 150},
          { title: "productCode", key: "productCode", tooltip: true, align: "center", width: 150},
          { title: "providerId", key: "providerId", tooltip: true, align: "center", width: 150},
          { title: "publicKey", key: "publicKey", tooltip: true, align: "center", width: 150},
          { title: "rasType", key: "rasType", tooltip: true, align: "center", width: 100},
          { title: "createDate", key: "createDate", tooltip: true, align: "center", width: 150},
          {
            title: "操作",
            width: "180px",
            align: "center",
            fixed:'right',
            render: (h, params) => {
              return h("div", [
                h(
                  "Button",
                  {
                    props: {
                      type: "text",
                      size: "small",
                    },
                    style: {
                      marginRight: "5px",
                      color:'#3795C8',
                    },
                    on: {
                      click: () => {
                        this.toDetail(params.row);
                      },
                    },
                  },
                  "查看"
                ),
                h(
                  "Button",
                  {
                    props: {
                      type: "text",
                      size: "small",
                    },
                    style: {
                      marginRight: "5px",
                      color:'#3795C8',
                    },
                    on: {
                      click: () => {
                        this.toEdit(params.row);
                      },
                    },
                  },
                  "编辑"
                ),
                h(
                  "Button",
                  {
                    props: {
                      type: "text",
                      size: "small",
                    },
                    style: {
                      marginRight: "5px",
                      color:'#FA6266',
                    },
                    on: {
                      click: () => {
                        this.deleteSingle(params.row.keyID);
                      },
                    },
                  },
                  "删除"
                ),
              ]);
            },
          },
        ],
        apiUrl: "secret/getList",
        search: {
          HospitalName: "",
          UserName: ""
        },
      },
    };
  },

  created: function () {},
  activated(){
    this.search()
  },
  methods: {
    search: function () {
      this.$refs.dataTable.initload();
    },

    toDetail: function (data) {
      this.detailModal = true;
      this.currentEditModel = JSON.parse(JSON.stringify(data));
    },

    toAdd: function () {
      this.$router.push({ path: "departmentAdd" });
    },

    toEdit: function (data) {
      this.editModal = true;
      this.currentEditModel = JSON.parse(JSON.stringify(data));
    },

    //单个删除
    deleteSingle: function (id) {
      this.$Modal.confirm({
        title: "确认要删除该密钥吗？",
        mask: false,
        onOk: () => {
          this.$api.get(`/secret/delete?keyId=${id}`).then((rsp) => {
            if (rsp != false) {
              this.$Message.success("删除成功");
              this.search();
            }
          });
        },
      });
    },

    //批量删除
    deleteBatch() {
      if (this.selectionData.length < 1) {
        this.$Message.warning("请先勾选数据");
      } else {
        let ids = [];
        this.selectionData.forEach((item) => {
          ids.push(item.keyID);
        });
        let _ids = ids.join(";");
        this.$Modal.confirm({
          title: "确认要批量删除选中的数据？",
          mask: false,
          onOk: () => {
            this.$api.post(`/secret/deleteBatch?ids=${_ids}`).then((rsp) => {
              if (rsp != false) {
                this.$Message.success("删除成功");
                this.search();
              }
            });
          },
        });
      }
    },

    //多选回调
    selectionChange(data) {
      this.selectionData = data;
    },
  },
};
</script>
<style scoped>
</style>